module.exports = __webpack_public_path__ + "img/channelkb_senario_icon.d50702f3.png";